import { Theme } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import withStyles from '@mui/styles/withStyles'
import React, { createContext, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { themeStyles } from 'themes'
import { TableCardRow } from './ThreeColumnTable-styles'

const useStyles = makeStyles<Theme>({
    tableStyles: {},
})

interface IContextProps {
    classes: any
}
const Context = createContext({} as IContextProps)

interface SimpleTableFrameProps {
    classes: any
}

const ThreeColumnTable: React.FC<SimpleTableFrameProps> = ({ classes, children }) => {
    return (
        <div className={classes.tableCard}>
            <div className={classes.tableCardContent}>
                <Context.Provider value={{ classes }}>{children}</Context.Provider>
            </div>
        </div>
    )
}

export default withStyles(themeStyles.useTableStyles)(ThreeColumnTable)

interface ThreeColumnTableHeaderProps {
    tableHeaders: Array<string>
}

export const ThreeColumnTableHeader: React.FC<ThreeColumnTableHeaderProps> = ({ tableHeaders }) => {
    const { t } = useTranslation()
    const { classes } = useContext(Context)

    return (
        <div className={classes.threeColumnTableCardHeader}>
            {tableHeaders.map((header, i) => (
                <div key={i}>{t(`${header}`)}</div>
            ))}
        </div>
    )
}

interface ThreeColumnTableRowProps {
    tableValues: Array<string>
}

export const ThreeColumnTableRow: React.FC<ThreeColumnTableRowProps> = ({ tableValues }) => {
    const { classes } = useContext(Context)

    return (
        <>
            <div className={classes.tableCardRow}>
                {tableValues.map((value, i) => (
                    <TableCardRow key={i} row={i}>
                        {value}
                    </TableCardRow>
                ))}
            </div>
        </>
    )
}
